import React from 'react';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

type DisableApiKeyDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  keyToDisable: { id: string; name: string } | null;
  handleDisableApiKey: () => Promise<void>;
  disableLoading: boolean;
  cancelRef: React.RefObject<HTMLButtonElement>;
};

const DisableApiKeyDialog = ({
  isOpen,
  onClose,
  keyToDisable,
  handleDisableApiKey,
  disableLoading,
  cancelRef,
}: DisableApiKeyDialogProps) => {
  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Disable API Key
          </AlertDialogHeader>

          <AlertDialogBody>
            Are you sure you want to disable the API key for "{keyToDisable?.name}"? This action
            cannot be undone.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="red"
              onClick={handleDisableApiKey}
              ml={3}
              isLoading={disableLoading}
            >
              Disable
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default DisableApiKeyDialog;
